import { Component, Input } from '@angular/core';
import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { Table } from '../table/types/table';

@Component({
  selector   : 'carfax-history',
  template: require('./carfax.history.component.html')
})
export class CarfaxHistoryComponent {
  @Input() displayRecords   : any;
  @Input() serviceCategories: any;

  flipped: boolean;

  tableSettings: Table = {
    columns: [
      {
        classes: 'text-left',
        field  : 'serviceName',
        header : {
          classes: 'text-left',
          text   : this.translateService.instant('JS_SPACE.CARFAX.SERVICE_TYPE')
        },
      },
      {
        classes: 'text-left',
        field  : 'dateOfLastService',
        header : {
          classes: 'text-left',
          text   : this.translateService.instant('VEHICLE_SPACE.LAST_SERVICE')
        },
      },
      {
        classes: 'text-left',
        field  : 'odometerOfLastService',
        header : {
          classes: 'text-left',
          text   : this.translateService.instant('VEHICLE_SPACE.ODOMETER')
        }
      }
    ],
    empty: {
      text: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.CARFAX.NO_SERVICES_FOUND')
    },
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
    static: true
  };

  constructor (
    public  activeModal     : NgbActiveModal,
    private translateService: TranslateService
  ) {}

  flipModal () : void {
    this.flipped = !this.flipped;
  }
}
